var map = {
	"./Emoji1.svg": 49568,
	"./Emoji10.svg": 84592,
	"./Emoji11.svg": 99393,
	"./Emoji12.svg": 17650,
	"./Emoji13.svg": 67043,
	"./Emoji14.svg": 23036,
	"./Emoji15.svg": 51581,
	"./Emoji16.svg": 39486,
	"./Emoji17.svg": 2063,
	"./Emoji18.svg": 43912,
	"./Emoji19.svg": 9305,
	"./Emoji2.svg": 20467,
	"./Emoji20.svg": 16329,
	"./Emoji21.svg": 81464,
	"./Emoji22.svg": 20299,
	"./Emoji23.svg": 1242,
	"./Emoji24.svg": 12869,
	"./Emoji25.svg": 58148,
	"./Emoji26.svg": 1271,
	"./Emoji27.svg": 13734,
	"./Emoji28.svg": 88593,
	"./Emoji29.svg": 25792,
	"./Emoji3.svg": 57826,
	"./Emoji30.svg": 16222,
	"./Emoji31.svg": 95151,
	"./Emoji32.svg": 16124,
	"./Emoji33.svg": 70397,
	"./Emoji34.svg": 36466,
	"./Emoji35.svg": 74403,
	"./Emoji36.svg": 29264,
	"./Emoji37.svg": 41505,
	"./Emoji38.svg": 18710,
	"./Emoji39.svg": 5831,
	"./Emoji4.svg": 16141,
	"./Emoji40.svg": 28311,
	"./Emoji41.svg": 22982,
	"./Emoji42.svg": 54757,
	"./Emoji43.svg": 73860,
	"./Emoji44.svg": 41451,
	"./Emoji45.svg": 47578,
	"./Emoji46.svg": 8745,
	"./Emoji47.svg": 83384,
	"./Emoji48.svg": 93599,
	"./Emoji49.svg": 78958,
	"./Emoji5.svg": 36428,
	"./Emoji50.svg": 84660,
	"./Emoji51.svg": 6293,
	"./Emoji52.svg": 69654,
	"./Emoji53.svg": 32871,
	"./Emoji54.svg": 30472,
	"./Emoji55.svg": 26489,
	"./Emoji56.svg": 77194,
	"./Emoji57.svg": 46011,
	"./Emoji58.svg": 43772,
	"./Emoji59.svg": 72317,
	"./Emoji6.svg": 8127,
	"./Emoji60.svg": 41917,
	"./Emoji61.svg": 13372,
	"./Emoji62.svg": 92399,
	"./Emoji63.svg": 29822,
	"./Emoji64.svg": 89729,
	"./Emoji65.svg": 74928,
	"./Emoji66.svg": 57379,
	"./Emoji67.svg": 7986,
	"./Emoji7.svg": 87022,
	"./Emoji8.svg": 40105,
	"./Emoji9.svg": 5240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94121;